module.exports = __webpack_public_path__ + "img/opportunity_filled.ce17f594.png";